import React from "react";
import { useSearchParams, useParams, Navigate } from "react-router-dom";
import QuestPerLocation from "./QuestPerLocation";

const QuestLocationWrapper = () => {
  const { id: locationId } = useParams();
  const [searchParams] = useSearchParams();
  const referralCode = searchParams.get("code");

  const accessToken =
    localStorage.getItem("accessToken") ||
    sessionStorage.getItem("accessToken");

  if (!accessToken && referralCode && referralCode.trim()) {
    const params = new URLSearchParams(searchParams);
    if (locationId) {
      params.set("location_id", locationId);
    }
    const targetUrl = `/invitation?${params.toString()}`;
    return <Navigate to={targetUrl} replace={true} />;
  }

  return <QuestPerLocation />;
};

export default QuestLocationWrapper;
